import React from 'react';
import Tag from '@hero/ui-kit/components/Tag';
import type { DripStatus } from '../../types';
const STATUS_TAG: Record<
    DripStatus,
    {
        type: 'primary' | 'warn' | 'success';
        label: string;
    }
> = {
    DRAFT: { type: 'primary', label: 'Draft' },
    ACTIVE: { type: 'success', label: 'Active' },
    PAUSED: { type: 'warn', label: 'Paused' }
};
type Props = {
    status: DripStatus;
};
const DripStatusPill: React.FC<Props> = ({ status }) => {
    const config = STATUS_TAG[status] ?? { type: 'primary' as const, label: status };
    return (
        <Tag type={config.type} size="small">
            {config.label}
        </Tag>
    );
};
export default DripStatusPill;
